import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { OtherliabilitiesandaccrualsSoletraderService } from './service/otherliabilitiesandaccruals-soletrader.service';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';


@Component({
  selector: 'app-otherliabilitiesandaccruals-soletrader',
  templateUrl: './otherliabilitiesandaccruals-soletrader.component.html',
  styleUrls: ['./otherliabilitiesandaccruals-soletrader.component.scss']
})
export class OtherliabilitiesandaccrualsSoletraderComponent implements OnInit {
  OtherliabilitiesandaccrualsSoletraderFormgGroup: FormGroup;

  Grid_Total1: number;
  Grid_Total2: number;
  isJump: any;
  NormalRoutng: boolean;
  disableOtherLiabilities: boolean
  showBubbledata: any;
  valid: boolean;

  constructor(private FormBuilder: FormBuilder, private OtherliabilitiesandaccrualsSoletraderService: OtherliabilitiesandaccrualsSoletraderService, public commonService: CommonService, private Router: Router, private sidenav: SideNavService) {

  }

  ngOnInit() {

    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.createformgroup();
    this.wizardrowslist.clear();
    this.GetOtherliabilitiesandaccrualsSoletrader();
    this.commonService.getNotesData();
  this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetOtherliabilitiesandaccrualsSoletrader_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.disableOtherLiabilities=true

  }

  createformgroup() {
    this.OtherliabilitiesandaccrualsSoletraderFormgGroup = this.FormBuilder.group({
      OtherLiabilitiesId: new FormControl(),
      MasterId: new FormControl(),
      OtherLiabilitiesSharePremiumSubtotal: new FormControl({ disabled: true, value: '' }),
      OtherLiabilitiesSharePremiumSubtotal_LY: new FormControl({ disabled: true, value: '' }),
      OtherLiabilitiesFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      MatchingData: new FormControl(),

      Wizardrows: this.FormBuilder.array([this.FormBuilder.group({
        DetailsId: new FormControl(),
        OtherLiabilitiesId: new FormControl(),
        DescriptionShareType: new FormControl(),
        OtherLiabilitiesSharePremiumSubtotal: new FormControl(),
        OtherLiabilitiesSharePremiumSubtotal_LY: new FormControl(),
        CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
        CreatedDate: new FormControl(),
        ModifiedBy: new FormControl(),
        ModifiedDate: new FormControl()
      })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        var MatchingData = this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['MatchingData'].value;
        this.OtherliabilitiesandaccrualsSoletraderFormgGroup.reset();
        this.wizardrowslist.clear();
        this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  GetOtherliabilitiesandaccrualsSoletrader() {
    debugger;
    this.OtherliabilitiesandaccrualsSoletraderService.getdata(this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      if (data.Wizardrows)
        for (let i = 0; i < data.Wizardrows.length; i++) {
          this.wizardrowslist.push(this.FormBuilder.group({
            OtherLiabilitiesId: data.Wizardrows[i].OtherLiabilitiesId,
            DetailsId: data.Wizardrows[i].DetailsId,
            DescriptionShareType: data.Wizardrows[i].DescriptionShareType,
            OtherLiabilitiesSharePremiumSubtotal: data.Wizardrows[i].OtherLiabilitiesSharePremiumSubtotal,
            OtherLiabilitiesSharePremiumSubtotal_LY: data.Wizardrows[i].OtherLiabilitiesSharePremiumSubtotal_LY,
          }));
        }
      this.OtherliabilitiesandaccrualsSoletraderFormgGroup.patchValue(data);
      this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  GetOtherliabilitiesandaccrualsSoletrader_LY() {
    debugger;
    this.OtherliabilitiesandaccrualsSoletraderService.getdata_LY(this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      this.showBubbledata = data;
      this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  On_Next() {
    debugger;
    if (this.Gridvalidations() && this.On_NextBalancesheatValidaton()) {
      this.OtherliabilitiesandaccrualsSoletraderService.insertdetails(this.OtherliabilitiesandaccrualsSoletraderFormgGroup.getRawValue()).subscribe(data => {
        this.OtherliabilitiesandaccrualsSoletraderFormgGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Other liabilities and accruals", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == "otherliabilitiesandaccruals") {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
   this.OtherliabilitiesandaccrualsSoletraderFormgGroup.markAsPristine();
    //this.Router.navigate(['/loansandoverdrawnbank']);
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else if (backpage == 'otherliabilitiesandaccruals') {
      this.Router.navigate(['/notes']);
    }
    else {
      backpage = this.commonService.getBackSelection("Other liabilities and accruals", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  AddNew() {
    debugger;
    if (this.Gridvalidations()) {
      this.valid = true;
      this.wizardrowslist.push(this.FormBuilder.group({ OtherLiabilitiesId: '', DescriptionShareType: '', OtherLiabilitiesSharePremiumSubtotal: '', OtherLiabilitiesSharePremiumSubtotal_LY: '', }));
    }
    //  this.wizardrowslist.clear();

  }

  DeleteRow(index) {
    debugger;
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((data) => {
      if (data.value) {
        this.wizardrowslist.removeAt(index);
        this.CalculationsGrid();
      }
    })
  }

  Gridvalidations() {
    if (this.wizardrowslist.length) {
      var data = [];
      for (var j = 0; j < this.wizardrowslist.length; j++) {
        var v = this.OtherliabilitiesandaccrualsSoletraderFormgGroup.value.Wizardrows.filter(x => x.DescriptionShareType == this.wizardrowslist.value[j].DescriptionShareType)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    for (var i = 0; i < this.OtherliabilitiesandaccrualsSoletraderFormgGroup.value.Wizardrows.length; i++) {
      if ((this.OtherliabilitiesandaccrualsSoletraderFormgGroup.value.Wizardrows.length > 0) && (this.OtherliabilitiesandaccrualsSoletraderFormgGroup.value.Wizardrows[i].DescriptionShareType == null || this.OtherliabilitiesandaccrualsSoletraderFormgGroup.value.Wizardrows[i].DescriptionShareType == "")) {
        //Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');
        this.valid = false;
        return false;
      }
      else {
        this.valid = true;
      }
    }
    return true;

  }

  CalculationsGrid() {
    debugger;
    this.Grid_Total1 = 0;
    this.Grid_Total2 = 0;
    // this.SharecapitalFormgGroup.value.CreateTaxationFormGroupGrid

    for (var i = 0; i < this.wizardrowslist.length; i++) {
      this.Grid_Total1 = this.Grid_Total1 + +this.wizardrowslist.value[i].OtherLiabilitiesSharePremiumSubtotal;
      this.Grid_Total2 = this.Grid_Total2 + +this.wizardrowslist.value[i].OtherLiabilitiesSharePremiumSubtotal_LY;
    }
    this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['OtherLiabilitiesSharePremiumSubtotal'].setValue(this.Grid_Total1)
    this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['OtherLiabilitiesSharePremiumSubtotal_LY'].setValue(this.Grid_Total2)

  }

  On_NextBalancesheatValidaton() {
    debugger;
    if (+this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['OtherLiabilitiesSharePremiumSubtotal'].value != this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['MatchingData'].value.Item1) {
      Swal.fire("Andica Accounts Production", "Total " + this.commonService.StartYear + " must tally with the Other Current Liabilities field value in the Trail balance for the year " + this.commonService.StartYear + ".", 'warning');

      //Swal.fire({
      //  text: "'OtherLiabilitiesSharePremiumSubtotal " + this.commonService.StartYear + " must tally with the 'Other liabilities and accruals' field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".",
      //  showConfirmButton: true,
      //  icon: 'warning',

      //})
      return false;
    }
    //else
    //  return true
    else if (+this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['OtherLiabilitiesSharePremiumSubtotal_LY'].value != this.OtherliabilitiesandaccrualsSoletraderFormgGroup.controls['MatchingData'].value.Item2) {
      Swal.fire("Andica Accounts Production", "Total " + this.commonService.LastYear + " must tally with the Other Current Liabilities field value in the Trail balance for the year " + this.commonService.LastYear + ".", 'warning');

      //Swal.fire({
      //  text: "'LoansAndOverdrawnBankSharePremiumSubtotal LY' at " + this.commonService.LastYear + " must tally with the 'Other liabilities and accruals' field value in the Statement of Financial Position for the year " + this.commonService.LastYear + ".",
      //  showConfirmButton: true,
      //  icon: 'warning',

      //})
      return false;
    }
    else
      return true
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.OtherliabilitiesandaccrualsSoletraderFormgGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

  get wizardrowslist() {
    return this.OtherliabilitiesandaccrualsSoletraderFormgGroup.get('Wizardrows') as FormArray;
  }

}
